import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    maxWidth: "100%",
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRaduis: "8px",
    p: 2,
};


interface IBasicModal {
    text: string;
    open: boolean;
    handleOpen: () => void;
    handleClose: () => void
    children: React.ReactNode;
}

export default function BasicModal({ children, text, open, handleClose, handleOpen }: IBasicModal) {

    return (
        <div>
            <Button
                variant="contained"
                onClick={handleOpen}>
                {text}
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    {children}
                </Box>
            </Modal>
        </div>
    );
}
